import { AxiosResponse } from "axios";
import { useQuery } from "@tanstack/react-query";
import { networkKeys } from "../../samples/queryKeys";
import networkApi from "../api";
import { UrlDom } from "../@types/Url";

const useDomPreview = (url: string, domUrl?: string) => {
  const { data, isLoading, isError } = useQuery<AxiosResponse<UrlDom>>({
    queryKey: networkKeys.urlPreview(url, domUrl),
    queryFn: () => networkApi.getDomPreviewAndLinks({ domUrl, url }),
    enabled: !!domUrl
  });

  return {
    urlDom: data?.data,
    isLoading,
    isError
  };
};

export default useDomPreview;
